import React, { useEffect, useState } from "react";
import axios from "axios";
import { Form, Button } from "react-bootstrap";
import { useOutletContext, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { faChevronRight, faHouse } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { bodyRequest, distributorQuick } from "../../helpers/utils";
import { endpoints } from "../../helpers/endpoints";
import Filter from "./components/Filter";
import Map from "../../components/Maps";
import Items from "./components/Items";
import useWindowDimensions from "../../helpers/WindowDimension";

import activityBanner from "../../assets/images/izu_desktop_banner.png";
import activityBannerMobile from "../../assets/images/izu_mobile_banner.png";
import shoppingBanner from "../../assets/images/izu-2.jpeg";
import shoppingBannerMobile from "../../assets/images/izu-2-mobile.png";

import "./style.scss";
import "react-loading-skeleton/dist/skeleton.css";
import SkeletonProducts from "./components/SkeletonProducts";

const Products = () => {
  /* eslint-disable no-unused-vars */
  const [
    language,
    wishlists,
    setWishlists,
    removeWishlist,
    categorySelected,
    setCategorySelected,
    wishlistInjection,
    addWishlist,
    changeLanguage,
  ] = useOutletContext();
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const options = [
    {
      value: "Rate-Ascending",
      label: t("rate_ascending"),
    },
    {
      value: "Rate-Descending",
      label: t("rate_descending"),
    },
    {
      value: "Name-Ascending",
      label: t("name_ascending"),
    },
    {
      value: "Name-Descending",
      label: t("name_descending"),
    },
  ];

  const [quickBooking, setQuickBooking] = useState([]);
  const [onRequest, setOnRequest] = useState([]);
  const [stateMap, setStateMap] = useState([]);
  const [services, setServices] = useState([]);
  const [geocodes, setGeocodes] = useState(false);
  const [fetching, setFetching] = useState(false);

  const [skeletonShow, setSkeletonShow] = useState("none");
  const [productsShow, setProductsShow] = useState("block");
  const [stateButton, setStateButton] = useState("quick");

  const [page, setPage] = useState(1);
  const [pageRequest, setPageRequest] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [totalPageOnRequest, setTotalPageOnRequest] = useState(1);
  const [token, setToken] = useState();

  const [selectedOption, setSelectedOption] = useState(options[0].value);

  const [category, setCategory] = useState("5");
  const [date, setDate] = useState("");
  const [priceRange, setPriceRange] = useState();
  const [keyword, setKeyword] = useState();

  const [pageName, setPageName] = useState("search_page");
  const [breadcrumbName, setBreadcrumbName] = useState("all_breadcrumb");
  const [imageHeader, setImageHeader] = useState();

  const [activeCategory, setActiveCategory] = useState("1");

  const productsRequest = bodyRequest;
  const langParams = searchParams.get("lang");

  const { width } = useWindowDimensions();

  useEffect(() => {
    stateButton === "quick"
      ? setServices(quickBooking)
      : setServices(onRequest);
  }, [quickBooking, onRequest]);

  const resetPayload = () => {
    productsRequest.request.Availability = {
      MergeMethod: 1,
      Window: {
        Size: 42,
        StartDate: new Date(),
      },
    };

    productsRequest.request.Campaign = {
      AdCampaignCode: "",
      DealCampaignCode: "",
    };

    productsRequest.request.Filter = {
      TagCritera: {},
      Type: "Service",
      Bookability: {},
    };

    delete productsRequest.request.Paging.Token;
  };

  useEffect(() => {
    searchParams.delete("pages");
    searchParams.delete("pages_request");
    setSearchParams(searchParams);

    setPage(1);
    setToken(null);
    productsRequest.request.Paging.PageNumber = 1;

    const wishlistsStorage = JSON.parse(localStorage.getItem("wishlists"));

    if (wishlistsStorage && wishlistsStorage.length > 0) {
      setWishlists(wishlistsStorage);
    }

    setPage(1);
    productsRequest.request.Paging.PageNumber = 1;

    resetPayload();

    productsRequest.request.Language = `${language}-JP`;

    const category = searchParams.get("category");
    const min = searchParams.get("min");
    const max = searchParams.get("max");
    const keyword = searchParams.get("keyword");
    const date = searchParams.get("date");
    const sort = searchParams.get("sort");
    if (category) {
      if (category === "5") {
        productsRequest.request.Filter.TagCriteria = {
          IndustryCategoryGroups: [1],
        };
        setCategory("5");
      } else {
        productsRequest.request.Filter.TagCriteria = {
          IndustryCategoryGroups: [category],
        };
        setCategory(category);
      }
    }

    if (min || max) {
      const maxCheck = max == "null" ? "" : max;
      productsRequest.request.Filter.Bookability.RateRange = {
        Min: min,
        Max: maxCheck,
      };
      setPriceRange(`${min}-${maxCheck}`);
    }

    if (date) {
      productsRequest.request.Availability.Window.StartDate = new Date(date);
      setDate(new Date(date));
    }

    if (keyword) {
      productsRequest.request.Filter.Names = [`%${keyword}%`];
      setKeyword(keyword);
    }

    if (sort) {
      setSelectedOption(sort);
      productsRequest.request.Sorting = [
        {
          By: `${sort.split("-")[0]}`,
          Direction: `${sort.split("-")[1]}`,
        },
      ];
    } else {
      productsRequest.request.Sorting = [
        {
          By: "Default",
          Direct: "Ascending",
        },
      ];
    }

    delete productsRequest.request.Filter.Ids;

    productsRequest.request.Language = `${language === "en" ? "en-US" : "ja-JP"
      }`;

    pageNames();
    getData();
  }, []);

  useEffect(() => {
    productsRequest.request.Language = `${language === "en" ? "en-US" : "ja-JP"
      }`;

    if (langParams === language) {
      pageNames();
      getData();
    }
  }, [language]);

  const resetPage = () => {
    setPage(1);
    searchParams.delete("pages");
    setToken(null);
  };

  useEffect(() => {
    stateMap &&
      stateMap.map((item) => {
        if (item.HasGeocodes) {
          setGeocodes(true);
        }
      });
  }, [stateMap]);

  const dispatchQuick = (page) => {
    productsRequest.request.ShortName = distributorQuick;
    productsRequest.request.Paging.PageNumber = page || 1;
    productsRequest.request.Paging.PageSize = 12;

    axios.post(endpoints.search, productsRequest).then((response) => {
      if (page && page > 1) {
        setServices((data) => [...data, ...response.data.Entities]);
        setQuickBooking((data) => [...data, ...response.data.Entities]);
      } else {
        setQuickBooking(response.data.Entities);
        setServices(response.data.Entities);
        setTotalPage(response.data.Paging.NumberOfPages);
        setToken(response.data.Paging.Token);
      }
      setProductsShow("block");
      setSkeletonShow("none");
      setFetching(false);
    });
  };

  // const dispatchRequest = (pageRequest) => {
  //   productsRequest.request.ShortName = distributorRequest;
  //   productsRequest.request.Paging.PageNumber = 1;
  //   productsRequest.request.Paging.PageSize = 12;

  //   axios.post(endpoints.search, productsRequest).then((response) => {
  //     if (pageRequest && pageRequest > 1) {
  //       setServices((data) => [...data, ...response.data.Entities]);
  //       setOnRequest((data) => [...data, ...response.data.Entities]);
  //       setSkeletonShow("none");
  //     } else {
  //       setOnRequest(response.data.Entities);
  //       setTotalPageOnRequest(response.data.Paging.NumberOfPages);
  //     }
  //   });
  // };

  const updateStateMap = (data) => {
    setStateMap((ss) => [...ss, ...data]);
  };
  const dispatchMap = () => {
    productsRequest.request.Paging = {};
    productsRequest.request.ShortName = distributorQuick;

    axios.post(endpoints.search, productsRequest).then((response) => {
      updateStateMap(response.data.Entities);
    });
  };

  // const dispatchMapOnRequest = () => {
  //   productsRequest.request.Paging = {};
  //   productsRequest.request.ShortName = distributorRequest;

  //   axios.post(endpoints.search, productsRequest).then((response) => {
  //     updateStateMap(response.data.Entities);
  //   });
  // };

  const getData = (payload) => {
    setSkeletonShow("block");

    if (payload?.page && payload?.page > 1) {
      productsRequest.request.Paging.PageNumber = payload?.page;
      searchParams.get("page", page);
      productsRequest.request.Paging.Token = token;
      delete productsRequest.request.Filter;
      delete productsRequest.request.Campaign;
      delete productsRequest.request.Availability;

      dispatchQuick(payload?.page);
      // } else if (payload?.pageRequest && payload?.pageRequest > 1) {
      //   productsRequest.request.Paging.PageNumber = payload?.pageRequest;
      //   dispatchRequest(payload?.pageRequest);
    } else {
      setProductsShow("none");
      dispatchQuick();
      dispatchMap();
      // dispatchRequest();
    }

    // dispatchMapOnRequest();
  };

  const setCategoryFilter = (cat) => {
    setActiveCategory(String(cat));
    const params = {
      category: String(cat),
    };

    filterData(params, "noParams");
  };

  const filterData = (values, type = "") => {
    resetPage();
    productsRequest.request.Filter = {
      Type: "Service",
      TagCriteria: {},
    };
    resetPayload();
    if (values.minRange) {
      if (values.minRange === "0") {
        productsRequest.request.Filter.Bookability.RateRange = {};
        searchParams.delete("min");
        searchParams.delete("max");
      } else {
        productsRequest.request.Filter.Bookability.RateRange = {
          Min: values.minRange,
          Max: values.maxRange,
        };
        searchParams.set("min", values.minRange);
        searchParams.set("max", values.maxRange);
      }
    }
    if (values.date) {
      productsRequest.request.Availability.Window.StartDate = new Date(
        values.date
      );
      searchParams.set("date", new Date(values.date));
    }

    if (values.category === "5") {
      productsRequest.request.Filter.TagCriteria = {
        IndustryCategoryGroups: [1, 2],
      };
      searchParams.delete("category");
    } else {
      productsRequest.request.Filter.TagCriteria = {
        IndustryCategoryGroups: [...values.category],
      };
      type !== "noParams" && searchParams.set("category", values.category);
    }

    if (values.keyword) {
      productsRequest.request.Filter.Names = [`%${values.keyword}%`];
      searchParams.set("keyword", values.keyword);
    } else {
      delete productsRequest.request.Filter.Names;
      searchParams.delete("keyword");
    }

    setSearchParams(searchParams);
    pageNames();

    getData();
  };

  const changeToRequest = () => {
    setServices(onRequest);
    setStateButton("request");
  };

  const changeToQuick = () => {
    setServices(quickBooking);
    setStateButton("quick");
  };

  const changeToMap = () => {
    setStateButton("map");
  };

  const onSort = (value) => {
    setSelectedOption(value);
    resetPage();
    productsRequest.request.Sorting = [
      {
        By: `${value.split("-")[0]}`,
        Direction: `${value.split("-")[1]}`,
      },
    ];
    searchParams.set("sort", value);
    setSearchParams(searchParams);
    getData();
  };
  const loadMore = () => {
    if (fetching) {
      return;
    }

    setFetching(true);
    // if (stateButton === "quick") {
    const paging = page + 1;
    searchParams.set("pages", paging);
    searchParams.delete("pages_request");
    setSearchParams(searchParams);

    setPage(paging);
    getData({ page: paging });
    // } else if (stateButton === "request") {
    //   const paging = pageRequest + 1;
    //   searchParams.delete("pages");
    //   searchParams.set("pages_request", paging);
    //   setSearchParams(searchParams);

    //   setPageRequest(paging);
    //   getData({ pageRequest: paging });
    // }
  };

  const pageNames = () => {
    let name = "";
    let breadcrumb = "";
    let image = "";
    const category = searchParams.get("category");
    switch (category) {
      case "5":
        name = "search_page";
        breadcrumb = "activity_breadcrumb";
        image = width < 992 ? activityBannerMobile : activityBanner;
        break;
      case "0":
        name = "accommodation";
        breadcrumb = "activity_breadcrumb";
        image = width < 992 ? activityBannerMobile : activityBanner;
        break;
      case "1":
        name = "activity";
        breadcrumb = "activity_breadcrumb";
        image = width < 992 ? activityBannerMobile : activityBanner;
        break;
      case "2":
        name = "restaurant";
        breadcrumb = "activity_breadcrumb";
        image = width < 992 ? activityBannerMobile : activityBanner;
        break;
      case "3":
        name = "shopping";
        breadcrumb = "shopping_breadcrumb";
        image = width < 992 ? shoppingBannerMobile : shoppingBanner;
        break;
      default:
        name = "search_page";
        breadcrumb = "activity_breadcrumb";
        image = width < 992 ? activityBannerMobile : activityBanner;
        break;
    }

    setImageHeader(image);
    setPageName(name);
    setBreadcrumbName(breadcrumb);
  };
  useEffect(() => {
    localStorage.setItem("wishlists", JSON.stringify(wishlists));
  }, [wishlists]);

  return (
    <div className="products">
      <div className="container">
        <div className="productsWrapper" style={{ display: productsShow }}>
          <p id="breadcrumbs">
            <div className="home">
              <FontAwesomeIcon icon={faHouse} />
            </div>
            <a href="http://kanko.city.izu.shizuoka.jp/index.html">
              {t("home")}
            </a>
            <div className="arrow">
              <FontAwesomeIcon icon={faChevronRight} />
            </div>
            <span className="breadcrumb_last" aria-current="page">
              {t(breadcrumbName)}
            </span>
          </p>
          {category && category === "3" ? (
            <div className="categories shopping">
              <div className="col">
                <a
                  href="/booking/?category=3"
                  className={`category shopping ${category === "3" ? "active" : ""}`}
                >
                  {t("shopping")}
                </a>
              </div>
            </div>
          ) : (
            <div className="categories">
              <div className="row">
                <div className="col">
                  <a
                    href="/booking/?category=1"
                    className={`category ${category === "1" ? "active" : ""
                      }`}
                  >
                    {t("activity")}
                  </a>
                </div>
                <div className="col">
                  <a
                    href="/booking/?category=0"
                    className={`category ${category === "0" ? "active" : ""}`}
                  >
                    {t("accommodation")}
                  </a>
                </div>
                {/* <div className="col">
                  <div
                    onClick={() => setCategoryFilter(2)}
                    className={`category ${
                      activeCategory === "2" ? "active" : ""
                    }`}
                  >
                    {t("restaurant")}
                  </div>
                </div> */}
              </div>
            </div>
          )}

          <Filter
            lang={language}
            filter={filterData}
            date={date}
            priceRange={priceRange}
            keyword={keyword}
            setDate={setDate}
            setCategory={setCategory}
            setPriceRange={setPriceRange}
            setKeyword={setKeyword}
          />
          <div className="d-flex flex-wrap justify-content-between productsOption mb-4">
            <div className="mb-3 mb-lg-0">
              <Button
                variant={stateButton === "quick" ? "primary" : "secondary"}
                onClick={() => changeToQuick()}
                className="me-2 me-lg-3 mb-2 mb-lg-0"
              >
                {t("quick_booking")}
              </Button>
              <Button
                variant={stateButton === "request" ? "primary" : "secondary"}
                onClick={() => changeToRequest()}
                className="me-2 me-lg-3 mb-2 mb-lg-0 d-none"
              >
                {t("request_book")}
              </Button>
              <Button
                variant={stateButton === "map" ? "primary" : "secondary"}
                onClick={() => changeToMap()}
              >
                {t("map")}
              </Button>
            </div>

            <div className="d-flex flex-wrap">
              <div className="me-3 mb-3 mb-lg-0 d-flex sort">
                <div className="text">{t("language")}:</div>
                <Form.Select
                  name="form-control"
                  onChange={(e) => changeLanguage(e)}
                  value={language}
                >
                  <option value="jp">Japanese(日本語)</option>
                  <option value="en">English(英語)</option>
                </Form.Select>
              </div>
              <div className="d-flex sort">
                <div className="text">{t("sort_by")}:</div>
                <Form.Select
                  value={selectedOption}
                  onChange={(e) => onSort(e.target.value)}
                >
                  {options.map((o) => (
                    <option key={o.value} value={o.value}>
                      {o.label}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </div>
          </div>
          <div
            className="productItems"
            style={{ display: stateButton !== "map" ? "block" : "none" }}
          >
            <Items
              services={services}
              loadMore={loadMore}
              totalPage={totalPage}
              currentPage={page}
              currentPageOnRequest={pageRequest}
              totalPageOnRequest={totalPageOnRequest}
              state={stateButton}
              addWishlist={addWishlist}
              removeWishlist={removeWishlist}
              wishlists={wishlists}
              category={category}
              wishlistInjection={wishlistInjection}
              skeletonShow={skeletonShow}
            />
          </div>
          <div
            className="productsMap"
            style={{ display: stateButton === "map" ? "block" : "none" }}
          >
            {geocodes && stateMap.length > 0 && (
              <Map positions={stateMap} zoom={11} />
            )}
          </div>
        </div>

        <div className="skeletonWrapper" style={{ display: skeletonShow }}>
          <SkeletonProducts currentPage={page} />
        </div>
      </div>
    </div>
  );
};

export default Products;
